// removed by extract-text-webpack-plugin
module.exports = {"logSelect":"_2myCKRvhvB1MvnTFPjCUEk"};